// extracted by mini-css-extract-plugin
export default {"RegisterMultiStepFormButton":"RegisterMultiStepForm_RegisterMultiStepFormButton__HKAuB"};